module.exports = "<div id='subscription-container'>\n  <iframe id='subscriptions-iframe' [src]='subAddress | safe' frameborder=\"0\"></iframe>\n</div>\n"